(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:RefereeList
   *
   * @description
   *
   */
  angular
    .module('neo.services')
    .factory('resultats2', resultats2);

  function resultats2($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/public/resultatapp2/:idPartit', {idPartit: '@_idPartit'}, {
      update: {
        method: 'PUT'
      },
      query: {
        method: 'GET',
        isArray: true
      }
    });
  }
}());